export const CONF = {};
export function setConfig(config) {
    // @ts-expect-error Tech debt (fix me CX-16279) - error enabled as part of CX-21272
    Object.keys(config).forEach((k) => (CONF[k] = config[k]));
}
